import React from 'react';
import PropType from 'prop-types';
import { CheckboxContainer, HiddenCheckbox, Icon, StyledCheckbox } from './styles/Checkbox.styles';

const Checkbox = ({ checked, handleChange, overrideCheckBoxColor, ...otherProps }) => (
  <CheckboxContainer>
    <HiddenCheckbox checked={checked} onChange={handleChange} {...otherProps} />
    <StyledCheckbox
      checked={checked}
      onClick={handleChange}
      overrideCheckBoxColor={overrideCheckBoxColor}
    >
      <Icon viewBox="0 0 24 24">
        <polyline points="20 6 9 17 4 12" />
      </Icon>
    </StyledCheckbox>
  </CheckboxContainer>
);

export default Checkbox;

Checkbox.propTypes = {
  checked: PropType.bool.isRequired,
  handleChange: PropType.func,
  overrideCheckBoxColor: PropType.string,
};

// checkbox color defaulted to green if no value is provided.
Checkbox.defaultProps = {
  handleChange: () => {},
  overrideCheckBoxColor: 'GREEN',
};
